import { withInstall } from '@bigin/utils'

import Badge from './src/badge.vue'

export const BBadge = withInstall(Badge)
export default BBadge

export * from './src/badge'
